import { useTranslation } from 'react-i18next';
import styled from 'styled-components'

const StyledContainer = styled.div`
    width: 100%;
    height: 100%;
    max-width: 375px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 24px 24px;
    position: relative;
    ${({ customStyles }) => customStyles || ''};

    & > * {
        width: 100%;
    } 
`;

export const AddressText = styled.div`
    position: absolute;
    bottom: ${({addressPosition}) => `${addressPosition}px`|| '11px'};
    text-align: center;
    max-width: 200px;
    color: ${(props) => props.theme.colors.colorWelcomeAddressText};
    font-size: ${(props) => props.theme.fontSizes.font12};
    font-weight: ${(props) => props.theme.fontWeights.extraLight};
`

const AppContainer = ({ customStyles, children, displayAddress = false, addressPosition = 11 }) => {
	const { t } = useTranslation();
	return (
		<StyledContainer customStyles={customStyles}>
			{children}
			{displayAddress && <AddressText addressPosition={addressPosition}>{t('usa_address')}</AddressText>}
		</StyledContainer>
	);
};

export default AppContainer;